/* The sample sale countdown.

   Liquid has already resolved the deadline the merchant typed - local
   Copenhagen wall-clock time - into one absolute instant, and printed it as an
   epoch. This file only counts down to that instant.

   That is the whole reason it is an instant rather than a number of seconds
   remaining: a visitor in New York counts to the same moment as one in Aarhus
   and sees the same "2 days 04:11:09", and a page served from cache is still
   right, because an absolute instant does not go stale the way a remaining
   count does.

   AT ZERO IT STOPS, IT DOES NOT GO NEGATIVE
   The clock is replaced by the merchant's ended message and the timer is
   dropped. There is no state where the page offers a sale that has closed.

   Only the digits that changed are rewritten each second, so a screen reader
   or a text-selection is not disturbed by the whole bar being rebuilt sixty
   times a minute. */
(function () {
    'use strict';

    var SELECTOR = '[data-dico-ss-countdown]';

    function pad(n) {
        return n < 10 ? '0' + n : String(n);
    }

    function setUnit(root, unit, value) {
        var el = root.querySelector('[data-unit="' + unit + '"]');
        if (el && el.textContent !== value) { el.textContent = value; }
    }

    function finish(root, message) {
        var p = document.createElement('p');
        p.className = 'dico-ss-ended';
        p.textContent = message;
        root.innerHTML = '';
        root.appendChild(p);
    }

    function start(root) {
        if (root.dicoRunning) { return; }
        root.dicoRunning = true;

        var ends = parseInt(root.getAttribute('data-ends'), 10);
        var message = root.getAttribute('data-ended-message') || '';

        /* No deadline set, or it is already past and Liquid rendered the ended
           message. Either way there is nothing to count. */
        if (!ends) { return; }
        if (!root.querySelector('[data-unit="seconds"]')) { return; }

        (function tick() {
            var left = ends - Math.floor(Date.now() / 1000);

            if (left <= 0) {
                finish(root, message);
                return;
            }

            setUnit(root, 'days', String(Math.floor(left / 86400)));
            setUnit(root, 'hours', pad(Math.floor((left % 86400) / 3600)));
            setUnit(root, 'minutes', pad(Math.floor((left % 3600) / 60)));
            setUnit(root, 'seconds', pad(left % 60));

            window.setTimeout(tick, 1000);
        }());
    }

    function scan() {
        var nodes = document.querySelectorAll(SELECTOR);
        for (var i = 0; i < nodes.length; i++) { start(nodes[i]); }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scan);
    } else {
        scan();
    }

    /* The theme editor re-renders whole sections, which replaces the element
       with a fresh one that has never been started. */
    document.addEventListener('shopify:section:load', scan);
}());